import apiV2 from '.'

export const actionLogsApi = apiV2.injectEndpoints({
  endpoints: builder => ({
    addActionLog: builder.mutation({
      query: ({ actionId, domainId, eventId, userId, companyId, extended }) => ({
        url: `/action-logs`,
        method: 'POST',
        body: { actionId, domainId, eventId, userId, companyId, extended },
      }),
    }),
  }),
})

export const { useAddActionLogMutation } = actionLogsApi
